import { render, staticRenderFns } from "./shiftManagementMainDialogCreate.vue?vue&type=template&id=5f08b97c&scoped=true"
import script from "./shiftManagementMainDialogCreate.vue?vue&type=script&lang=js"
export * from "./shiftManagementMainDialogCreate.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementMainDialogCreate.vue?vue&type=style&index=0&id=5f08b97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08b97c",
  null
  
)

export default component.exports